// extracted by mini-css-extract-plugin
export default {"buttons":"deleteCategory_buttons__9lETW","closeBtn":"deleteCategory_closeBtn__LfcTF","save":"deleteCategory_save__amu2U","close":"deleteCategory_close__va5Ia"};